var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUniversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85368 2.53085C9.94106 2.46774 10.059 2.46774 10.1464 2.53085L18.0609 8.24689C18.3967 8.4894 18.8655 8.41379 19.1081 8.07799C19.3506 7.7422 19.275 7.27338 18.9392 7.03087L11.0247 1.31483C10.413 0.873084 9.5871 0.873083 8.97545 1.31483L1.06094 7.03087C0.725143 7.27338 0.649527 7.7422 0.892046 8.07799C1.13456 8.41379 1.60338 8.4894 1.93917 8.24689L9.85368 2.53085ZM3.25 9.74999V15.25C3.25 15.6642 3.58579 16 4 16C4.41421 16 4.75 15.6642 4.75 15.25V9.74999C4.75 9.33578 4.41421 8.99999 4 8.99999C3.58579 8.99999 3.25 9.33578 3.25 9.74999ZM7.25 15.25V9.74999C7.25 9.33578 7.58579 8.99999 8 8.99999C8.41421 8.99999 8.75 9.33578 8.75 9.74999V15.25C8.75 15.6642 8.41421 16 8 16C7.58579 16 7.25 15.6642 7.25 15.25ZM11.25 9.74999V15.25C11.25 15.6642 11.5858 16 12 16C12.4142 16 12.75 15.6642 12.75 15.25V9.74999C12.75 9.33578 12.4142 8.99999 12 8.99999C11.5858 8.99999 11.25 9.33578 11.25 9.74999ZM15.25 15.25V9.74999C15.25 9.33578 15.5858 8.99999 16 8.99999C16.4142 8.99999 16.75 9.33578 16.75 9.74999V15.25C16.75 15.6642 16.4142 16 16 16C15.5858 16 15.25 15.6642 15.25 15.25ZM1.75 17.5C1.33579 17.5 1 17.8358 1 18.25C1 18.6642 1.33579 19 1.75 19H18.25C18.6642 19 19 18.6642 19 18.25C19 17.8358 18.6642 17.5 18.25 17.5H1.75Z",
    fill: "#647FB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9414 4.3123L5.08604 7.81895C5.00739 7.87576 5.04757 8.00002 5.14459 8.00002H14.8553C14.9523 8.00002 14.9925 7.87576 14.9139 7.81895L10.0585 4.3123C10.0235 4.28706 9.97635 4.28706 9.9414 4.3123Z",
    fill: "#647FB4",
    fillOpacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUniversity);
export default __webpack_public_path__ + "static/media/icon-university.4f4a33e352cf3c2d46d9e59c7cf9d34e.svg";
export { ForwardRef as ReactComponent };